import React, { useReducer, useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { withHeaderMessages } from "../higherOrderComponents/WithHeaderMessages";
import { Address } from "../lib/components/Address";
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { LoadingSpinner } from "../lib/components/LoadingSpinner";
import { PhoneNumber } from "../lib/components/PhoneNumber";

const CustomerProfile = (props) => {
  const initialState = {
    customers: [],
    isLoading: true,
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "customers":
        return {
          ...state,
          customers: action.payload,
          isLoading: false,
        };
      case "isLoading":
        return {
          ...state,
          isLoading: action.payload,
        };
      default:
        throw new Error();
    }
  };

  const [customersState, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    async function getCustomerProfile() {
      dispatch({ type: "isLoading", payload: true });
      await props.header.setHeader("customerProfile");
      await props.api
        .get("/api/customer/profile")
        .then((response) => {
          if (response.status === 200) {
            return response.data;
          }
        })
        .then((data) => {
          dispatch({ type: "customers", payload: data });
        })

        .then(hideLoader)
        .catch(hideLoader);
    }
    getCustomerProfile();
  }, []);

  const hideLoader = () => {
    dispatch({ type: "isLoading", payload: false });
  };

  return (
    <>
      {customersState.isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {!customersState.customers ||
          customersState.customers.length === 0 ? (
            <Container className="mt-2">
              <p>No customer assigned.</p>
            </Container>
          ) : (
            <div>
              {customersState.customers.map((customer, customerIndex) => (
                <Container key={customerIndex} className="pt-4">
                  <Row>
                    <Col
                      sm={12}
                      className="section"
                      style={{ paddingLeft: "15px" }}
                    >
                      <h2>
                        Name:{" "}
                        <a>
                          <strong>{customer.name}</strong>
                        </a>
                      </h2>
                    </Col>
                  </Row>
                  <div className="row">
                    <div className="col-sm-12 page-banner">
                      PROVIDER LOCATION(S)
                    </div>
                  </div>
                  <Row className="section mt-30">
                    <Col sm={12}>
                      {customer.providers && (
                        <table
                          className="provider-location-table"
                          style={{ width: "100%" }}
                        >
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Physical Address</th>
                              <th>Mailing Address</th>
                              <th className="phone-column">Phone</th>
                              <th>Email</th>
                            </tr>
                          </thead>
                          <tbody>
                            {customer.providers.map((p, providerIndex) => (
                              <tr key={providerIndex}>
                                <td>{p.name}</td>
                                <td>
                                  <Address address={p.address} />
                                </td>
                                <td>
                                  <Address address={p.mailingAddress} />
                                </td>
                                <td>
                                  {p?.phoneNumber &&
                                    PhoneNumber({ phoneNumber: p.phoneNumber })}
                                </td>
                                <td>
                                  {(p.emailAddresses || []).map(
                                    (e, emailIndex) => (
                                      <div key={emailIndex}>
                                        {e.emailAddress}
                                        <br />
                                      </div>
                                    ),
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </Col>
                  </Row>
                  <div></div>
                </Container>
              ))}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default withHeaderMessages(WithApiAccess(CustomerProfile));
